import { getIdToken } from "../userAuth";
import config from "../../config";

const { API } = config;

export function sendInvite(invite) {
  return getIdToken()
    .then((token) => token)
    .then((token) =>
      fetch(`${API}/notifications/invite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(invite),
      }),
    )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw Error(`${response.status} ${response.statusText}`);
    });
}

export function sendCollaboratorEmail(email) {
  return getIdToken()
    .then((token) => token)
    .then((token) =>
      fetch(`${API}/notifications/collaborator-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(email),
      }),
    )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw Error(`${response.status} ${response.statusText}`);
    });
}

export const contactEmail = async (values) => {
  try {
    const response = await fetch(`${API}/notifications/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    if (response.status === 200) {
      return response.json();
    }
    if (response.status === 404) {
      return {};
    }
    throw Error(`${response.status} ${response.statusText}`);
  } catch (error) {
    throw error;
  }
};

export function reportProblem(body) {
  return getIdToken()
    .then((token) => token)
    .then((token) =>
      fetch(`${API}/notifications/report-problem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }),
    )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw Error(`${response.status} ${response.statusText}`);
    });
}

export function sendFeedback(feedback) {
  return getIdToken()
    .then((token) => token)
    .then((token) =>
      fetch(`${API}/notifications/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(feedback),
      }),
    )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw Error(`${response.status} ${response.statusText}`);
    });
}

export function exerciseCompletion(body) {
  return getIdToken()
    .then((token) => token)
    .then((token) =>
      fetch(`${API}/notifications/exercise-completion`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }),
    )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw Error(`${response.status} ${response.statusText}`);
    });
}
